import { useCallback, useEffect } from "react";
import { Capacitor } from "@capacitor/core";
// RevenueCat runs in the app shells only, so it is loaded there, not with every web page.
const purchases = () => import("@revenuecat/purchases-capacitor").then((m) => m.Purchases);
import { User } from "@/models/auth";

type PurchasesConfigTypes = {
    apiKey: string;
    appUserID?: string;
};

export function usePaymentConfig(user: User, offerings: any, setOfferings: (o: any) => void) {
    const public_apple_api_key = "appl_DNEBYogsWNyxldysidPVItHMkiT";
    const public_google_api_key = "goog_WAcvFMuzarNalZjeqWQBDBFPvny";

    const paymentConfig = useCallback(async () => {
        if (Capacitor.getPlatform() === "ios") {
            const config: PurchasesConfigTypes = { apiKey: public_apple_api_key };
            if (user?.user_id) config.appUserID = user.user_id.toString();
            await (await purchases()).configure(config);
        } else if (Capacitor.getPlatform() === "android") {
            const config: PurchasesConfigTypes = { apiKey: public_google_api_key };
            if (user?.user_id) config.appUserID = user.user_id.toString();
            await (await purchases()).configure(config);
        }
    }, [user]);

    const fetchOfferings = useCallback(async () => {
        const offeringsResponse = await (await purchases()).getOfferings();
        if (offeringsResponse.current !== null && offeringsResponse.current.availablePackages.length !== 0) {
            setOfferings(offeringsResponse.current.availablePackages);
        }
    }, [setOfferings]);

    useEffect(() => {
        if (!user.subscription_plan) return;
        if (Capacitor.getPlatform() === "web") return;
        if (offerings) return;
        paymentConfig()
            .then(fetchOfferings)
            .catch((e) => console.error("Error setting up purchases", JSON.stringify(e)));
    }, [user, offerings, paymentConfig, fetchOfferings]);
}
